import { io } from "socket.io-client";
import { API_URL } from "./config";

const URL = process.env.NODE_ENV === "production" ? API_URL : API_URL;

export const socket = io(URL, { autoConnect: false });
